export default __webpack_public_path__ + "fddcc4d5ac4ea92304febecca682c248.svg";